export default __webpack_public_path__ + "static/media/hmd_grid_xl.f32cd154.jpg";